<template>
  <div v-if="!showResponse" class="dashboard">
    <div>
      <p class="user">Bienvenido {{ authStore.user.nombre }}</p>
      <p class="color-gray">A continuación podrás observar el estado actual de tu cuenta en H2O.</p>
    </div>
    <PasesContratados :pases="pasesStore.pasesFormateados" />
    <PasesReservados :pasesReservados="pasesStore.pasesReservados" @edit="openMenu" />
    <Button
      id="btn-reservar"
      class="mt-20"
      type="button"
      text="Reservar pase"
      classtype="primary"
      @click="goToReserva(null)"
    />
    <MenuPases :isOpen="isOpen" @close="closeMenu" @edit="editPase" @anular="anularPase" />
  </div>
  <Response
    v-else
    :success="responseSuccess"
    :title="responseTitle"
    :message="responseMessage"
    buttonText="Ver mis pases"
    :goToPage="DASHBOARD"
    @click="setAnuladoFalse"
    showButton="yes"
  />
</template>
<script setup>
import { onMounted, ref } from "vue"
import { useAuthStore, usePasesStore, useClasesStore } from "@/store"
import { goToReserva, DASHBOARD, OK } from "@/helpers/"
import PasesContratados from "../components/PasesContratados.vue"
import PasesReservados from "../components/PasesReservados.vue"
import Button from "../components/Button.vue"
import MenuPases from "../components/MenuPases.vue"
import Response from "../components/Response.vue"

const pasesStore = usePasesStore()
const clasesStore = useClasesStore()

pasesStore.cleanPaseSelected()

onMounted(() => {
  pasesStore.getUserPases().then(() => {
    clasesStore.getClases(pasesStore.arrayIdActividadesPases)
  })
})

const authStore = useAuthStore()
const paseClaseSelected = ref(null)

const isOpen = ref(false)

const openMenu = (value) => {
  paseClaseSelected.value = value
  document.querySelectorAll(".menu-pases button").forEach((button) => (button.disabled = false))
  isOpen.value = true
}

const closeMenu = () => {
  isOpen.value = false
}

const editPase = () => {
  const { idPase, idActividadClase } = getPaseActividad()
  pasesStore.setPaseSelected(idPase, idActividadClase)
  goToReserva(paseClaseSelected.value, idPase, idActividadClase)
}

const getPaseActividad = () => {
  const pase_completo = pasesStore.pasesReservados.filter((p) => p.id == paseClaseSelected.value)
  if (pase_completo.length > 0) {
    return pase_completo[0]
  } else {
    return { idPase: 0, idActividadClase: 0 }
  }
}

const showResponse = ref(false)

const setAnuladoFalse = () => {
  showResponse.value = false
}

const responseSuccess = ref(false)

const responseTitle = ref("")
const responseMessage = ref("")

const anularPase = async () => {
  await pasesStore.cancelPase(paseClaseSelected.value).then((response) => {
    if (response.result == OK) {
      responseSuccess.value = true
      paseClaseSelected.value = null
      responseTitle.value = "¡Pase anulado correctamente!"
      responseMessage.value = "Has anulado con éxito el pase a una actividad."
    } else {
      responseSuccess.value = false
      responseTitle.value = "¡Error, el pase no pudo ser anulado!"
      responseMessage.value = response.message
    }
    isOpen.value = false
    showResponse.value = true
  })
}
</script>
<style>
.dashboard {
  text-align: left;
  display: flex;
  flex-direction: column;
  padding: 0 28px;
  max-width: 360px;
  gap: 20px;
}

.user {
  font-size: 1.5rem;
}

@media (min-width: 720px) {
  .user {
    font-size: 1.875rem;
  }

  .dashboard {
    max-width: 640px;
  }
}
</style>
